const HomeTabId = {
  SIMULADOR: 'simulador',
  AREA_CLIENTE: 'area_cliente',
}
export default HomeTabId
